import classNames from "classnames";
import Link from 'next/link';
import cssButtonStyles from "src/components/button/Button.module.css";
import styles from "./ButtonLink.module.css";

//#region [Props]
type ButtonLinkProps = {
    className?: string;
    inverse?: boolean;
    isOutline?: boolean;
    children: React.ReactNode;
    href: string;
    target?: string;
    borderStyle?: "round" | "square";
};
//#endregion

//#region [Component]
export default function ButtonLink({ className, inverse = false, isOutline = false, href, children, target, borderStyle = "round" }: ButtonLinkProps) {
    return <Link href={href} legacyBehavior passHref target={target}>
        <a
            className={classNames(cssButtonStyles.CoreButton, styles.ButtonLink, className, {
                [cssButtonStyles.square]: borderStyle === 'square',
                [cssButtonStyles.inverse]: inverse,
                [cssButtonStyles.outline]: isOutline
            })}
        >
            {children}
        </a>
    </Link>;
}
//#endregion